import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { formatDateTimeBR, getCargoTypes, renderCargoTypes } from "../../../../helpers/format";
import { STATUS_OPERACOES_PATIO_SPE } from "../../../../helpers/status";
import { useModal } from "../../../../hooks/ModalContext";
import { useAuth } from "../../../../hooks/AuthenticateContext";
import api from "../../../../services/api";
import Create from "./Create";
import Info from "./Info";
import { IOperacaoPatioSPE } from "./types/types";
import ModalHistory from "../../../../components/ModalHistory";
import Can from "../../../../components/Can";

const OperacoesPatioSPE: React.FC = () => {
  const [columns] = useState<ColumnDef[]>([
    {
      field: "id_operacao_patio_SPE",
      headerName: "ID Pátio SPE",
      filter: true,
    },
    {
      field: "data_entrada",
      headerName: "Data de Entrada",
      filter: true,
      type: "dateColumn",
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }
        return "---";
      },
    },
    {
      field: "placa_dianteira",
      fieldName: "placa",
      headerName: "Placa Dianteira",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => params.value || "---",
    },
    {
      field: "tipo_carga",
      fieldName: "tipo_carga",
      headerName: "Tipo de Carga",
      filter: true,
      filterParams: {
        selected: {
          isMultiple: false,
          data: getCargoTypes()
        }
      },
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return String(renderCargoTypes(params.value));
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => params.value || "---",
    },
  ]);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<IOperacaoPatioSPE>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isHistory, setIsHistory] = useState<boolean>(false);

  const { isModalOpen, openModal, closeModal } = useModal();
  const { user } = useAuth();
  const gridRef = useRef<any>();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_operacao_patio_SPE: rowId,
        id_usuario_historico: user?.id,
      };

      await api.post("/deletar/operacaoPatioSpe", body);
      setLoading(false);
      setIsRemove(false);
      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, [user]);

  return (
    <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
      <Loading loading={loading} />
      {isModalOpen && (
        <Create
          isEdit={isEdit}
          isView={isView}
          selectedRow={selectedRow}
          onClear={() => closeModal()}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(false)}
          onConfirm={() => onDelete(selectedRow?.id_operacao_patio_SPE)}
          row={String(selectedRow?.id_operacao_patio_SPE)}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Detalhes - Triagens SPE"
          onClose={() => setIsView(false)}
        />
      )}

      {isHistory && selectedRow && (
        <ModalHistory
          isOpen={isHistory}
          title="Histórico - Triagens SPE"
          historyRoute="/historico/operacaoPatioSpe"
          bodyKey="id_operacao_patio_SPE"
          bodyValue={selectedRow.id_operacao_patio_SPE ?? 0}
          onClose={() => setIsHistory(false)}
        />
      )}

      <div className="flex items-center justify-between w-full mb-3">
        <div>
          <h1 className="text-2xl text-[#000000] font-bold">Triagens SPE</h1>
        </div>
        <div className="mr-14 flex items-center gap-4">
          <Can acao="SALVAR">
          <button
            className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
            onClick={() => {
              setSelectedRow(undefined);
              setIsEdit(false);
              setIsView(false);
              openModal();
            }}
            id="btnCreatePatioSPE"
          >
            Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
          </button>
          </Can>
        </div>
      </div>
      <div className="flex w-full">
        <Grid
          ref={gridRef}
          columns={columns}
          filters={[]}
          pagination
          path="/listar/operacaoPatioSpe"
          onDelete={(data: any) => {
            setIsRemove(true);
            setSelectedRow(data);
          }}
          isShowStatus={true}
          status={STATUS_OPERACOES_PATIO_SPE}
          onView={(data: any) => {
            setSelectedRow(data);
            setIsView(true);
          }}
          onUpdate={(data: any) => {
            setSelectedRow(data);
            setIsEdit(true);
            setIsView(false);
            openModal();
          }}
          onHistory={(data: any) => {
            setSelectedRow(data);
            setIsHistory(true);
          }}
        />
      </div>
    </div>
  );
};

export default OperacoesPatioSPE;
